import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirectorChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDirectorChair"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V11H22V13H19.2928L13.8484 16.5L20.3811 20.6996L19.2995 22.3819L11.9991 17.6888L4.6987 22.3819L3.61719 20.6996L10.1499 16.5L4.70546 13H2V11H4V2ZM8.40397 13L11.9991 15.3112L15.5943 13H8.40397Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirectorChair;
